$(function () {
    var noticeEl = $('<div style="display: none; clear: both; padding: .5rem; text-align: center; color: #fff; background-color: #e53d46; font-size: .9rem !important; line-height: 1.2;" />');

    var emailNoticeData = {
        datastate: 'empty',
        emailPrefix: [],
        emailDomain: [],
        showNotice: function (selected) {
            var str = selected.val().split("@");
            var parentEl = $(selected).parent();
            var showNoticeConditionsMet = ($.inArray(str[0], emailNoticeData.emailPrefix) > -1) || ($.inArray(str[1], emailNoticeData.emailDomain) > -1);

            if (showNoticeConditionsMet) {
                parentEl.append(noticeEl);
                noticeEl.text("Prefix/domain prohibits delivery of email. To ensure delivery, we recommend using a different email address.");
                noticeEl.show();
            } else {
                noticeEl.hide();
            }
        }
    };

    $("body").on("keyup", "input[id$='tbEmail'], input.emailEntry, input[type=email]", function () {
        var selector = $(this);

        if (emailNoticeData.datastate == 'empty') {
            emailNoticeData.datastate = 'loading';

            var onSuccess = function (msg) {
                if (msg != null) {
                    emailNoticeData.emailPrefix = msg[0];
                    emailNoticeData.emailDomain = msg[1];
                    emailNoticeData.datastate = 'loaded';
                }
            };

            $.ajax({
                type: "POST",
                url: "/webservices/ACEMethods.svc/GetProhibitedEmail",
                data: JSON.stringify({}),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: onSuccess,
                error: function (err) { ACE.ErrorLogger.RecordClientError(err) }
            });
        }

        if (emailNoticeData.datastate == 'loaded') emailNoticeData.showNotice(selector);
    });
});
